import { api } from "../../utils";
import {
  CREATE_COMPLAIN,
  CREATE_LOCATION,
  DELETE_LOCATION,
  GET_COMPLAINS,
  GET_LOCATIONS_BY_STORE,
  GET_SINGLE_LOCATION,
  UPDATE_LOCATION,
} from "../ApiConstants";

class LocationApi {
  static sharedIstance = new LocationApi();

  constructor() {
    if (LocationApi.sharedIstance != null) {
      return LocationApi.sharedIstance;
    }
  }

  //   Get location by store ID  ...
  async getLocationsByStore(id) {
    try {
      const response = await api.get(`${GET_LOCATIONS_BY_STORE}${id}`);
      const { success, data } = response.data;
      if (success) {
        return data;
      }
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  //   Create Store  ..
  async createLocation(body) {
    try {
      const response = await api.post(CREATE_LOCATION, body);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  //   Get single Store ..
  async getSingleLocation(id) {
    try {
      const response = await api.get(`${GET_SINGLE_LOCATION}/${id}`);
      const { success, data } = response.data;
      if (success) {
        return data;
      }
    } catch (error) {
      return error.response.data;
    }
  }

  //   Delete store ..
  async deleteLocation(id) {
    try {
      const response = await api.delete(`${DELETE_LOCATION}/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  //   Update store ..
  async updateLocation(body, id) {
    try {
      const response = await api.put(`${UPDATE_LOCATION}/${id}`, body);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  // Create Complain ..

  async createComplain(body) {
    try {
      const response = await api.post(`${CREATE_COMPLAIN}`, body);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  // Get Complains  ..
  async getComplains() {
    try {
      const response = await api.get(`${GET_COMPLAINS}`);
      const { success, data } = response.data;

      if (success) {
        return data;
      }
    } catch (error) {}
  }
}

export default LocationApi.sharedIstance;
